<div class="dialog-header">
  <div class="dialog-header-title">{{ 'game.dialogs.enterPassword.title' | translate }}</div>

  <div class="dialog-header-close-button">
    <button (click)="close()">
      <svg-icon
        src="assets/img/icons/dialog-close.svg"
        [stretch]="true"
        [applyClass]="true"
        class="dialog-header-close-button-icon"
      />
    </button>
  </div>
</div>

<div class="dialog-content app-game-dialog-enter-password-content">
  <app-input
    [placeholder]="'game.dialogs.enterPassword.placeholder' | translate"
    type="password"
    [formControl]="password"
    icon="https://data.createpoker.app/app/game/assets/devryops-ltxf/login/login_password.png"
  ></app-input>
  <div class="app-game-dialog-enter-password-content-error" *ngIf="showWrongPasswordError$ | async"><i class="bi bi-exclamation-circle-fill"></i> {{ 'game.dialogs.enterPassword.errorIncorrect' | translate }}</div>
</div>

<div class="dialog-footer">
  <div class="dialog-footer-buttons">
    <button appButton type="button" (click)="onCancel()">{{ 'common.actions.cancel' | translate }}</button>
    <button
      appButton
      type="button"
      class="success"
      [disabled]="password.invalid"
      (click)="onSubmit()"
      [isLoading]="loading$ | async"
    >
      {{ 'common.actions.submit' | translate }}
    </button>
  </div>
</div>
